import { Box } from '@mui/system';
import { IStyles } from '../../../commonUtils/styleUtils';
import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';
import ImageWrapper from '../ImageWrapper';
import { Typography } from '@mui/material';

const styles: IStyles = {
  root: {
    all: 'unset',
    width: { xs: '100%', md: pxTovW(680) },
    height: { md: pxTovW(179) },
    borderRadius: { xs: pxToRem(15), md: pxTovW(30) },
    display: 'flex',
    cursor: 'pointer',
  },

  extraDataRoot: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(10), md: pxTovW(10) },
    paddingX: { xs: pxToRem(5), md: pxTovW(12) },
    paddingY: { xs: pxToRem(5), md: pxTovW(7) },
    borderRadius: { xs: pxToRem(3), md: pxTovW(8) },
  },
};
interface IVariants {
  small: string;
  regular: string;
}
const variantWidth = {
  xs: { small: '100%', regular: '100%' },
  md: { small: pxTovW(547), regular: pxTovW(780) },
  lg: { small: pxTovW(447), regular: pxTovW(680) },
};
const variantHeight = {
  // xs: { small: pxToRem(75), regular: pxToRem(88) },
  xs: { small: 'max-content', regular: 'max-content' },
  md: { small: pxTovW(120), regular: pxTovW(179) },
  lg: { small: pxTovW(100), regular: pxTovW(179) },
};

interface IAssessmentButtonProps {
  backgroundColor: string;
  imageName?: string;
  variant: keyof IVariants;
  clickHandler?: () => void;
  heading: { bold: string; regular: string };
  headingData?: { value: string; text: string }[];
}
export const AssessmentButton = (props: IAssessmentButtonProps) => {
  const {
    backgroundColor,
    imageName,
    clickHandler,
    variant,
    heading,
    headingData,
  } = props;

  return (
    <Box
      component="button"
      sx={{
        ...styles.root,
        backgroundColor: backgroundColor || 'white',
        width: {
          xs: variantWidth.xs[variant],
          md: variantWidth.md[variant],
          lg: variantWidth.lg[variant],
        },
        height: {
          xs: variantHeight.xs[variant],
          md: variantHeight.md[variant],
          lg: variantHeight.lg[variant],
        },
      }}
      onClick={clickHandler}
    >
      {imageName && (
        <ImageWrapper
          name={imageName}
          type="png"
          parentFolder="illustrations"
          styles={{
            width: { xs: pxToRem(88), md: 'unset' },
            height: { xs: 'unset', md: '100%' },
          }}
        />
      )}

      <Box
        sx={{
          width: '100%',
          paddingX: { xs: pxToRem(8), md: pxTovW(15) },
          paddingY: { xs: pxToRem(15), md: pxTovW(30) },
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          gap: { xs: pxToRem(10), md: pxTovW(0) },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: { xs: 'end', md: 'center' },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: { xs: 'flex-start', md: 'center' },
              gap: { xs: pxToRem(5), md: pxTovW(10) },
            }}
          >
            <Typography
              variant="h3"
              fontWeight="bold"
              sx={{ fontSize: { xs: pxToRem(18), md: pxTovW(37) } }}
            >
              {heading.bold}
            </Typography>
            <Typography
              variant="h3"
              fontWeight="regular"
              sx={{ fontSize: { xs: pxToRem(14), md: pxTovW(37) } }}
            >
              {heading.regular}
            </Typography>
          </Box>

          <ImageWrapper
            styles={{
              width: {
                xs: pxToRem(23),
                md: variant === 'regular' ? pxTovW(45) : pxTovW(30),
              },
              height: {
                xs: pxToRem(24),
                md: variant === 'regular' ? pxTovW(45) : pxTovW(30),
              },
            }}
            name="right-arrow-circle"
            type="png"
            parentFolder="illustrations"
          />
        </Box>

        {headingData && headingData.length > 0 ? (
          <Box
            sx={{
              display: 'flex',
              gap: { xs: pxToRem(10), md: pxTovW(10) },
            }}
          >
            {headingData.map((data, index) => (
              <ExtraData
                key={index}
                dataValue={data.value}
                dataText={data.text}
                // backgroundColor={'#FFFFEF'}
                backgroundColor={'#F7FFEF'}
              />
            ))}
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

interface IExtraDataProps {
  dataValue: string;
  dataText: string;
  backgroundColor: string;
}
const ExtraData = (props: IExtraDataProps) => {
  const { dataValue, dataText, backgroundColor } = props;

  return (
    <Box sx={{ ...styles.extraDataRoot, backgroundColor: backgroundColor }}>
      <Typography
        variant="h3"
        color="neutral.royalBlue"
        fontWeight="bold"
        sx={{ fontSize: { xs: pxToRem(12), md: pxTovW(25) } }}
      >
        {dataValue}
      </Typography>
      <Typography
        variant="h3"
        sx={{ fontSize: { xs: pxToRem(10), md: pxTovW(18) } }}
      >
        {dataText}
      </Typography>
    </Box>
  );
};
